import * as React from 'react';
import { Placement, Modifier } from '@popperjs/core';

import { CKToastVariant } from '../components/CKToast';

type UnionFromTuple<T> = T extends (infer U)[] ? U : never;

export const Enum = <T extends string[]>(...args: T) => {
  return Object.freeze(
    args.reduce((acc, next) => {
      return {
        ...acc,
        [next]: next,
      };
    }, Object.create(null)) as { [P in UnionFromTuple<typeof args>]: P }
  );
};
export type Enum<T extends object> = T[keyof T];

export const CKTextFieldVariant = Enum('default', 'success', 'error');
export type CKTextFieldVariant = Enum<typeof CKTextFieldVariant>;

export const CKDialogSize = Enum('xxs', 'xs', 'sm', 'md', 'lg', 'xl', 'xxl');
export type CKDialogSize = Enum<typeof CKDialogSize>;

export interface Toast {
  id: string;
  autoHideDuration?: number;
  variant?: CKToastVariant;
  heading: string | React.ReactNode;
  description?: string | React.ReactNode;
  icon?: React.ReactNode;
}

export interface ItemBase {
  label: string;
  value: string;
}

export interface CommonSelectProps<T extends ItemBase> {
  placeholder: string;
  leftIcon?: React.ReactNode;
  popperZIndex?: number;
  popperWidth?: string;
  popperPlacement?: Placement;
  popperOffset?: number[];
  popperModifiers?: Partial<Modifier<any, any>>[];
  itemMetaRenderer?: (item: T) => React.ReactNode;
  isItemDisabled?: (item: T) => boolean;
}

export const CKPickerVariant = Enum('default', 'success', 'error');
export type CKPickerVariant = Enum<typeof CKPickerVariant>;
